<template>
  <section class="padlet-cards-section">
    <h3 v-if="title" class="section-heading">
      {{ title }} <span class="label">{{ count }}</span>
    </h3>
    <padlet-list v-if="xList" :walls="walls" :sort-by="sortBy" :actions="actions" />
    <padlet-cards v-else :walls="walls" :sort-by="sortBy" :actions="actions" />
  </section>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import PadletList from './padlet_list'
import PadletCards from './padlet_cards'
import device from 'bits/device'
export default {
  components: { PadletList, PadletCards },
  props: {
    walls: {
      default: [],
    },
    sortBy: {
      default: 'updatedAt',
    },
    title: {},
    actions: {
      default: false,
    },
  },
  computed: {
    count: function () {
      return this.walls.length
    },
    xList() {
      return this.isPhone || device.phone
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/3/modules/all';

section {
  margin-top: 32px;
}

.section-heading {
  font-weight: 500;
  font-size: $subheading-font-size;
  padding: 8px 24px;

  .label {
    margin-left: 0.25em;
    display: inline-block;
    font-weight: normal;
    color: var(--caption-text-color);
  }
}

@include respondToPortraitTablet {
  section .section-heading {
    padding: 8px 20px;
  }
}

@include respondToPhone {
  section .section-heading {
    font-size: 14px;
    padding: 8px 16px;
  }

  section {
    margin-top: 16px;
  }
}
</style>
